import ServicePageTemplate from './ServicePageTemplate';
import { webDevelopmentCourseModasaConfig } from './trainingPageConfigs';

const WebDevelopmentCourseModasa = () => <ServicePageTemplate {...webDevelopmentCourseModasaConfig} />;

export default WebDevelopmentCourseModasa;